import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { INVOCATION_GRID2D__view } from '../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_IMAGE__create_mask_gradient } from '../../_invocations/image/INVOCATION_IMAGE__create_mask_gradient';
import { INVOCATION_IMAGE__viewport } from '../../_invocations/image/INVOCATION_IMAGE__viewport';
import { ENUM__graph_template_name } from '../sd_1/ENUM__graph_template_name';

//todo: mb need use image_mask to grid2d view
export function GENERATION_TOOL__image_mask__create_gradient() {
  let out = new DTO__generation_tool();
  out.name = ENUM__graph_template_name.IMAGE_MASK__CREATE_GRADIENT;

  const graph = DTO_GRAPH__instance.CREATE_NEW();
  out.graph = graph;

  const node__grid2d_view = INVOCATION_GRID2D__view.create_node_for(graph);

  /*
   * LATENTS TO IMAGE
   */
  const node__mask_gradient = INVOCATION_IMAGE__create_mask_gradient.create_node_for(graph);

  graph.edge__try_add_for_fields(node__mask_gradient.out__image_mask_gradient, node__grid2d_view.image);

  const node__viewport = INVOCATION_IMAGE__viewport.CREATE_VIEWPORT_FOR(graph, node__mask_gradient.image_mask);

  /*
   *
   */
  let fields__visible = [node__viewport.image, node__mask_gradient.edge_radius, node__mask_gradient.minimum_denoise];

  out.view__add({ fields__visible, fields__stored: fields__visible });

  /*
   *
   */

  return out;
}
